var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_vm._m(0),_c('div',{staticClass:"b-btn"},[_c('div',{staticClass:"l"},[_vm._v("价格￥"+_vm._s(_vm.price))]),_c('div',{staticClass:"r",on:{"click":_vm.goBuy}},[_vm._v(" 立即购买 ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('img',{attrs:{"src":require("../../assets/image/huiyuankaitong.png")}})])
}]

export { render, staticRenderFns }